export default __webpack_public_path__ + "static/media/minteed-social.6a1ccb10.png";